import api from './api';
import { 
  Expense, 
  ExpenseCategory, 
  ExpenseBudget, 
  BankAccount, 
  BankTransaction,
  ExpenseFormData,
  ExpenseBudgetFormData,
  BankAccountFormData,
  BankTransactionFormData,
  ExpenseFilters,
  ExpenseStats
} from '../types/expense';

export const expenseService = {
  // Danh mục chi phí
  getCategories: async (): Promise<ExpenseCategory[]> => {
    const response = await api.get('/api/expenses/categories');
    return response.data;
  },

  createCategory: async (category: Omit<ExpenseCategory, 'id' | 'created_at' | 'updated_at'>): Promise<{ id: number; message: string }> => {
    const response = await api.post('/api/expenses/categories', category);
    return response.data;
  },

  // Chi phí
  getExpenses: async (filters?: ExpenseFilters): Promise<Expense[]> => {
    const params = new URLSearchParams();
    if (filters?.category_id) params.append('category_id', filters.category_id.toString());
    if (filters?.payment_status) params.append('status', filters.payment_status);
    if (filters?.date_from) params.append('date_from', filters.date_from);
    if (filters?.date_to) params.append('date_to', filters.date_to);
    if (filters?.supplier_id) params.append('supplier_id', filters.supplier_id.toString());
    if (filters?.created_by) params.append('created_by', filters.created_by.toString());

    const response = await api.get(`/api/expenses?${params.toString()}`);
    return response.data;
  },

  createExpense: async (expense: ExpenseFormData): Promise<{ id: number; expense_number: string; message: string }> => {
    const response = await api.post('/api/expenses', expense);
    return response.data;
  },

  updateExpense: async (id: number, expense: ExpenseFormData): Promise<{ message: string }> => {
    const response = await api.put(`/api/expenses/${id}`, expense);
    return response.data;
  },

  deleteExpense: async (id: number): Promise<{ message: string; deleted_expense: any }> => {
    const response = await api.delete(`/api/expenses/${id}`);
    return response.data;
  },

  approveExpense: async (id: number): Promise<{ message: string }> => {
    const response = await api.put(`/api/expenses/${id}/approve`);
    return response.data;
  },

  // Thống kê
  getExpenseStats: async (year?: number): Promise<ExpenseStats> => {
    const params = year ? `?year=${year}` : '';
    const response = await api.get(`/api/expenses/stats${params}`);
    return response.data;
  },

  // Ngân sách
  getBudgets: async (year?: number, month?: number): Promise<ExpenseBudget[]> => {
    const params = new URLSearchParams();
    if (year) params.append('year', year.toString());
    if (month) params.append('month', month.toString());

    const response = await api.get(`/api/expenses/budgets?${params.toString()}`);
    return response.data;
  },

  createBudget: async (budget: ExpenseBudgetFormData): Promise<{ id: number; message: string }> => {
    const response = await api.post('/api/expenses/budgets', budget);
    return response.data;
  },

  // Tài khoản ngân hàng
  getBankAccounts: async (): Promise<BankAccount[]> => {
    const response = await api.get('/api/expenses/bank-accounts');
    return response.data;
  },

  createBankAccount: async (account: BankAccountFormData): Promise<{ id: number; message: string }> => {
    const response = await api.post('/api/expenses/bank-accounts', account);
    return response.data;
  },

  // Giao dịch ngân hàng
  getBankTransactions: async (accountId?: number, type?: string, dateFrom?: string, dateTo?: string): Promise<BankTransaction[]> => {
    const params = new URLSearchParams();
    if (accountId) params.append('account_id', accountId.toString());
    if (type) params.append('type', type);
    if (dateFrom) params.append('date_from', dateFrom);
    if (dateTo) params.append('date_to', dateTo);

    const response = await api.get(`/api/expenses/bank-transactions?${params.toString()}`);
    return response.data;
  },

  createBankTransaction: async (transaction: BankTransactionFormData): Promise<{ id: number; message: string }> => {
    const response = await api.post('/api/expenses/bank-transactions', transaction);
    return response.data;
  }
};
